import moment from 'moment';

const setting = {
  /**
   * 文件大小转换
   */
  getFileSize: (fileByte) => {
    const fileSizeByte = fileByte;
    let fileSizeMsg = '';
    if (fileSizeByte < 1048576) fileSizeMsg = `${(fileSizeByte / 1024).toFixed(2)}KB`;
    else if (fileSizeByte == 1048576) fileSizeMsg = '1MB';
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = `${(fileSizeByte / (1024 * 1024)).toFixed(2)}MB`;
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = '1GB';
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = `${(fileSizeByte / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    else fileSizeMsg = '文件超过1TB';
    return fileSizeMsg;
  },
  /**
   * 转换时分秒
   */
  setTime: (time) => {
    const tempTime = moment.duration(Number(time) * 1000);
    const hour = tempTime.hours() < 10 ? `0${tempTime.hours()}` : tempTime.hours();
    const min = tempTime.minutes() < 10 ? `0${tempTime.minutes()}` : tempTime.minutes();
    const sec = tempTime.seconds() < 10 ? `0${tempTime.seconds()}` : tempTime.seconds();
    return { hour, min, sec }; // 返回时分秒
  },
  // 下载保存文档
  saveAs: (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }
  },
};

export default setting;



// WEBPACK FOOTER //
// ./src/utils/setting.js